module.exports = {"server":"https://certificacion.probolivia.gob.bo/ws","timeSessionExpired":30,"debug":false,"onbeforeunload":false,"port":443,"subDomain":"/","portDev":443}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 198
// module chunks = 0